var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounterTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "counter-transparent",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1377.57,1215.96h-3.29a0.926,0.926,0,0,1-.92-0.93v-6.02h-3.49v6.02a0.926,0.926,0,0,1-.92.93h-3.29a2.565,2.565,0,0,1-2.56-2.56v-8.49h-2.57a0.912,0.912,0,0,1-.85-0.57,0.891,0.891,0,0,1,.2-1l11.08-11.07a0.933,0.933,0,0,1,.65-0.27,0.956,0.956,0,0,1,.66.27l11.08,11.07a0.891,0.891,0,0,1,.2,1,0.912,0.912,0,0,1-.85.57h-2.57v8.49A2.565,2.565,0,0,1,1377.57,1215.96Zm-2.36-1.85h2.36a0.721,0.721,0,0,0,.72-0.71v-9.41a0.922,0.922,0,0,1,.92-0.92h1.26l-8.86-8.84-8.85,8.84h1.26a0.891,0.891,0,0,1,.65.27,0.875,0.875,0,0,1,.27.65v9.41a0.721,0.721,0,0,0,.72.71h2.36v-6.02a0.935,0.935,0,0,1,.93-0.93h5.33a0.935,0.935,0,0,1,.93.93v6.02Z",
    transform: "translate(-1359.59 -1192)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterTransparent);
export default __webpack_public_path__ + "static/media/counter-transparent.7bf708583a8cfb9ede8eb2eb5e4e5fb1.svg";
export { ForwardRef as ReactComponent };